import React, { useState, useEffect, useRef } from 'react'

import lib from 'lib/commons'

const CountTime = ({ delta, endTime }) => {
  const [days, setDays] = useState('')
  const [hours, setHours] = useState('')
  const [minutes, setMinutes] = useState('')
  const [seconds, setSeconds] = useState('')
  let countDownDate = new Date(lib.convertDateForIos(endTime)).getTime();
  let distance

  useInterval(() => {
    let now = new Date().getTime() + delta;

    distance = countDownDate - now;

    // let days = Math.floor(distance / (1000 * 60 * 60 * 24));
    // let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));

    setDays(lib.format2digits(Math.floor(distance / (1000 * 60 * 60 * 24))))
    setHours(lib.format2digits(Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))))
    setMinutes(lib.format2digits(Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))))
    setSeconds(lib.format2digits(Math.floor((distance % (1000 * 60)) / 1000)))

    if(distance <= 0) {
      setDays('00')
      setHours('00')
      setMinutes('00')
      setSeconds('00')
      window.location.reload();
    }
  }, distance <= 0 ? null : 1000)

  return (
    <>
      <span className="item-time">
        {days.toString().split('').map((d, i) => (
          <span key={i+d}>{d}</span>
        ))}
      </span> ngày &nbsp;
      <span className="item-time">
        {hours.toString().split('').map((h, k) => (
          <span key={k+h}>{h}</span>
        ))}
      </span>:
      <span className="item-time">
        {minutes.toString().split('').map((m, i) => (
          <span key={i+m}>{m}</span>
        ))}
      </span>:
      <span className="item-time">
        {seconds.toString().split('').map((s, i) => (
          <span key={i+s}>{s}</span>
        ))}
      </span>
    </>
  )
}

const useInterval = (callback, delay) => {
  const savedCallback = useRef();

  // Remember the latest function.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    function tick() {
      savedCallback.current();
    }
    if (delay !== null) {
      let id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
}

export default CountTime
